{
  "id": "hermes",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Hermes",
    "en": "Hermes"
  },
  "icon": "gods/hermes",
  "portrait": "gods/hermes-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "centaur": 1
  },
  "unlocks": ["centaur", "sylvan-lore", "winged-messenger", "spirited-charge"],
  "powers": ["ceasefire"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "ClassicalAgeHermes: CreateUnit Centaur at a Temple (one free myth unit), god power CeaseFire (cooldown 240 s); enables the listed unit and techs."
  }
}
